import { render } from "./RouteStats.vue?vue&type=template&id=51f58b19&scoped=true"
import script from "./RouteStats.vue?vue&type=script&lang=ts"
export * from "./RouteStats.vue?vue&type=script&lang=ts"

import "./RouteStats.vue?vue&type=style&index=0&id=51f58b19&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-51f58b19"

export default script